export type KifuLoader = {
  isModalOpen: boolean;
};

export function getInitialKifuLoaderState() {
  return { isModalOpen: false };
}
